import Anchor from "./Anchor";
import { AnchorProps } from "./types";

export default Anchor;
export type { AnchorProps };
